import Container from "./Container";

export default function Footer() {
  return (
    <footer className="vp-footer d-none d-lg-block">
      <Container className="d-flex flex-wrap justify-content-between gap-2">
        <span>VVR ERP — Customer Portal</span>
        <span className="opacity-75">
          Payments are recorded offline. This portal shows your records; it does not take payments.
        </span>
      </Container>
    </footer>
  );
}
